<template>
    <div class="table_group">
        <div class="status">
            <h2>{{ codecName }}</h2>
            <a
                v-if="isEditable"
                @click.stop="removeCodec(idCodec)"
                class="btn btn_action btn_delete"
                :title="'Smazat' | translate"
                v-translate>Smazat</a>
            <a
                v-if="availableStreamProfiles.length > 0 && isEditable"
                class="add add_expand"
                :class="{ open: this.addStreamProfileOpened }"
                @click.stop="toggleAddStreamProfile"
                :title="'Přidat profil streamu' | translate"
                v-translate>Přidat profil streamu</a>
        </div>

        <div class="filter expand_content" :class="{ open: addStreamProfileOpened }">
            <div class="field_left">
                <select-box :id="'streamProfile-'+codecName" v-model="selectedStreamProfile" :options="streamProfileOptions" ref="addStreamProfileSelectRef">
                    <translate class="translate">Profil streamu</translate>
                </select-box>
            </div>

            <div class="field_right">
                <p class="field">
                    <input class="btn" type="submit" :value="'Přidat' | translate" @click.stop="addStreamProfile" />
                </p>
            </div>
        </div>

        <table class="vypis vypis_detail">
            <thead class="no_sortable">
                <tr>
                    <th class="no_padding drag_drop" />
                    <th class="no_padding_left"><span class="name" v-translate>Profil streamu</span></th>
                    <th class="no_padding_left"><span class="name" v-translate>Kód profilu streamu</span></th>
                    <th class="no_padding edit" />
                </tr>
            </thead>
            <tbody :class="[{sortable: isEditable}, 'sortable_' + idCodec]">
                <tr
                    v-for="idStreamProfile in streamPofileIds"
                    :rowid="idStreamProfile"
                    :class="'sorted_profiles_' + idCodec"
                    :key="'profile_' + idCodec + '_' + idStreamProfile"
                >
                    <td class="no_padding drag_drop"><span /></td>

                    <td class="first_data no_padding_left">{{ getProfileName(idStreamProfile) }}</td>
                    <td class="first_data no_padding_left">{{ getProfileCode(idStreamProfile) }}</td>

                    <td class="no_padding edit">
                        <div class="edit_inner">
                            <a
                                v-if="isEditable"
                                class="btn btn_action btn_delete"
                                @click.stop="removeStreamProfile(idStreamProfile)"
                                :title="'Smazat' | translate" v-translate>Smazat</a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

export default {
    name: "StreamProfileOrder",
    props: {
      idCodec: Number|String,
      streamPofileIds: Array,
      streamProfiles: Array,
      codecs: Array,
      isEditable: Boolean,
    },
    data() {
        return {
            addStreamProfileOpened: false,
            selectedStreamProfile: null,
        }
    },
    mounted() {
        $('.sortable_' + this.idCodec).sortable({
            stop: this._updateSortedStreamProfiles
        });
    },
    methods: {
        getProfileName(idStreamProfile) {
            let streamProfile = this.streamProfiles.find((streamProfile) => streamProfile.id == idStreamProfile);
            return streamProfile ? streamProfile.name : null;
        },
        getProfileCode(idStreamProfile) {
          let streamProfile = this.streamProfiles.find((streamProfile) => streamProfile.id == idStreamProfile);
          return streamProfile ? streamProfile.code : null;
        },
        removeCodec() {
            this.$emit('removeCodec', this.idCodec);
        },
        removeStreamProfile(idStreamProfile) {
            this.$emit('removeStreamProfile', this.idCodec, idStreamProfile);
        },
        toggleAddStreamProfile() {
            this.addStreamProfileOpened = !this.addStreamProfileOpened;
            if (this.addStreamProfileOpened) {
                this.selectedStreamProfile = this.availableStreamProfiles[0].id;
            }
        },
        addStreamProfile() {
            this.$emit('addStreamProfile', this.idCodec, ~~this.selectedStreamProfile);
        },
        _updateSortedStreamProfiles() {
            const newStreamProfileSort = [];

            $('.sorted_profiles_' + this.idCodec).each((el, x) => {
                newStreamProfileSort.push(~~$(x).attr('rowid'));
            });

            this.$emit('sortStreamProfile', this.idCodec, newStreamProfileSort);
        }
    },
    computed: {
        codecName() {
            let codec = this.codecs.find((codec) => codec.id == this.idCodec);
            return codec ? codec.name : null;
        },
        availableStreamProfiles() {
            let streamProfiles = this.availableStreamProfilesByIdCodec.filter((streamProfile) => !this.streamPofileIds.includes(streamProfile.id));

            if (streamProfiles.length > 0) {
                this.selectedStreamProfile = streamProfiles[0].id;
            } else {
                this.addStreamProfileOpened = false;
            }

            return streamProfiles;
        },
        streamProfileOptions() {
            return this._.map(this.availableStreamProfiles, function (item) {
                return {id: item['id'], text: item['name'] +' ('+item['code']+')'}
            })
        },
        availableStreamProfilesByIdCodec() {
            return this.streamProfiles.filter((streamProfile) => {
                return streamProfile.id_codec === ~~this.idCodec;
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceTypes/components/StreamProfileOrder.vue